import { render } from "./AlbumCollaborators.vue?vue&type=template&id=66719485&scoped=true&ts=true"
import script from "./AlbumCollaborators.vue?vue&type=script&lang=ts"
export * from "./AlbumCollaborators.vue?vue&type=script&lang=ts"

import "./AlbumCollaborators.vue?vue&type=style&index=0&id=66719485&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66719485"]])

export default __exports__